<template>
  <div>
    <div>
      <h1 class="mdn-Heading mdn-Heading--sm">Provedores multa</h1>

      <div class="btn-container">
        <ModosWebBotaoExportarComponent :campos="filtro" @exportar="handleExportarMultaProvedores" />
        <button type="button"
          class="btn-toggle mb-3 v-btn v-btn--has-bg theme--light v-size--default primary button-orientation"
          @click="alternarFiltro">
          {{ mostrarFiltro ? 'Ocultar filtros' : 'Mostrar filtros' }}
        </button>
        <ModosWebFiltroInlineCollapseComponent ref="filtroInline" :campos="camposFiltrosComputed" :key="filtroKey"
          :inicialOpen="mostrarFiltro" :esconderBotao="true" @open-change="mostrarFiltro = $event"
          @modosWebFormFilterDadosClick="aplicarFiltro" @modosWebFormFilterDadosChange="(d) => { }"
          @modosWebFormFilterLimpar="resetarFiltro" />
      </div>

      <template v-if="provedores.length">
        <SGPPaginacaoComponent :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao?.current_page || 1">

          <SGPTabelaComponent :colunas="colunas" :dados="provedores" :usuarioPodeEditar="false"
            :usuarioPodeExcluir="false" :botaoInline="false" :somenteLeitura="true"
            @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
            @sgpTabelaEditarSelecionadoEmit="editarSelecionado" @sgpTabelaVincularSelecionadoEmit="handleBotaoCustom">
            <template v-slot:item.visualizar="{ item }">
              <SGPFormBotaoComponent
                fab
                rounded
                color="warning"
                @click="navegarParaProvedor(item)"
                x-small
              >
                <v-icon color="white" small>mdi-eye</v-icon>
              </SGPFormBotaoComponent>
            </template>
          </SGPTabelaComponent>

        </SGPPaginacaoComponent>
      </template>

      <SGPAlertaComponent v-else />
      <SGPLoadingComponent v-if="loadingProvedoresMulta" />
    </div>
  </div>
</template>

<style scoped>
.btn-container {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  justify-content: flex-end !important;
  flex-wrap: wrap;
  align-items: flex-start;
}

.btn-container > :last-child {
  flex: 0 0 100%;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import ModosWebFiltroInlineCollapseComponent from '@/common/modosweb-components/ModosWebFiltroInlineCollapseComponent.vue'
import ModosWebBotaoExportarComponent from '@/common/modosweb-components/ModosWebBotaoExportarComponent.vue'

export default {
  name: 'ctrlProvedoresMultaPage',

  components: {
    ModosWebFiltroInlineCollapseComponent,
    ModosWebBotaoExportarComponent
  },

  data() {
    return {
      mostrarFiltro: false,
      provedoresSelecionados: [],
      provedorSelecionado: {},
      filtro: {},
      filtroKey: 1
    }
  },

  created() {
    this.listarProvedoresMulta(this.montarParametros());
  },

  computed: {
    ...mapGetters('ctrlProvedoresMulta', [
      'listaDeProvedoresMulta',
      'loadingProvedoresMulta',
      'paginacaoProvedores'
    ]),

    provedores() {
      return this.listaDeProvedoresMulta.map(item => ({
        ...item,
        sla_excedente_percentual: item.sla_excedente_percentual != null 
          ? `${item.sla_excedente_percentual}%` 
          : '-',
        visualizar: `/workflow/ctrl-provedor-multa/${item.id}`,
      }));
    },

    paginacao() {
      return this.paginacaoProvedores;
    },

    camposFiltrosComputed() {
      return [
        { name: 'nome', type: 'text', label: 'Provedor' },
        { name: 'ultima_atualizacao_multa', type: 'month', label: 'Periodo' },
      ]
    },

    colunas() {
      return [
        {
          key: 'nome',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'total_pco_workflow_com_multa',
          label: 'Total de tickets com multa',
          sortable: false
        },
        {
          key: 'total_valor_multa',
          label: 'Valor total da multa',
          sortable: false
        },
        {
          key: 'sla_excedente_minutos',
          label: 'Minutos excedentes SLA',
          sortable: false
        },
        {
          key: 'sla_excedente_percentual',
          label: 'Minutos excedentes SLA(%)',
          sortable: false
        },
        {
          key: 'visualizar',
          label: 'Visualizar'
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlProvedoresMulta',
      [
        'listarProvedoresMulta',
        'setFiltroData',
        'exportarMultaProvedores',
      ]),

    async handleExportarMultaProvedores(dados) {
      await this.exportarMultaProvedores({
        ...dados.filtro,
        formato: dados.formato
      });
    },

    alternarFiltro() {
      this.mostrarFiltro = !this.mostrarFiltro;

      if (this.$refs.filtroInline?.toggleOpen) {
        this.$refs.filtroInline.toggleOpen();
      }
    },

    resetarFiltro() {
      this.filtro = {};

      this.listarProvedoresMulta(this.montarParametros({
        page: 1,
        current_page: 1
      }));

      this.filtroKey++;
    },

    gerenciadorDeSelecionados(selecionados) {
      this.provedoresSelecionados = selecionados;
    },

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra,
      }
    },

    async aplicarFiltro(dados) {
      this.filtro = dados || {};
      await this.listarProvedoresMulta(this.montarParametros({
        ...this.filtro,
        page: 1,
        current_page: 1
      }));
    },

    realizarPaginacao(paginate) {
      const current = paginate.current_page || 1;
      const perPage = paginate.per_page || 20;

      this.listarProvedoresMulta(
        this.montarParametros({
          page: current,
          current_page: current,
          per_page: perPage,
          ...this.filtro
        })
      );
    },

    navegarParaProvedor(item) {

      const filtroData = this.filtro?.ultima_atualizacao_multa 
        ? { ultima_atualizacao_multa: this.filtro.ultima_atualizacao_multa }
        : null;
      
      this.setFiltroData(filtroData);
      
      this.$router.push({
        name: 'ctrl-provedor-multa',
        params: { ctrl_provedor_id: item.id }
      });
    },
  }
}
</script>
